module.exports = __webpack_public_path__ + "static/media/analytices3.29f79406.png";